module.exports = __webpack_public_path__ + "img/cover.35ed98f0.png";